import IlustracaoDestaque from 'assets/img/destaque-ilustracao.png';
import { FOCO_VISIVEL } from 'utils/foco';

import { limparEFocarNaBuscaDaFilaEcoa } from './IndicadoresEFiltrosDaFilaEcoa';

export interface VazioDaFilaEcoaProps {
  /** A lista ficou vazia por causa da busca ou de um indicador. */
  porFiltro: boolean;
  onLimparFiltros: () => void;
}

/** ECN-55: fila vazia pelos filtros, com "Limpar filtros" (foco na busca, ECN-65), ou porque nada chegou à validação. */
export default function VazioDaFilaEcoa({ porFiltro, onLimparFiltros }: VazioDaFilaEcoaProps) {
  return (
    <div className="flex flex-wrap items-center gap-[26px] rounded-jj-lg border border-dashed border-surface-300 bg-brand-white p-[30px]">
      <img src={IlustracaoDestaque} alt="" className="h-auto w-[150px] shrink-0" />
      <div className="flex min-w-[240px] flex-1 flex-col gap-2.5">
        <p className="m-0 font-display text-base font-bold text-brand-blue-dark">
          {porFiltro ? 'Nenhuma ação nesta seleção' : 'Nenhuma Ação ECOA chegou à sua validação nesta fase'}
        </p>
        <p className="m-0 max-w-[460px] text-[12.5px] leading-[1.6] text-content-soft">
          {porFiltro
            ? 'Ajuste os indicadores ou a busca para encontrar as ações desta fase.'
            : 'Quando os integrantes da Ecoa cadastrarem ações nesta fase, elas aparecem aqui para você dar ciência, validar e bonificar.'}
        </p>
        {porFiltro && (
          // SPEC_DEVIATION: fundo `brand-blue-dark` no lugar do `brand-blue` do design (amarelo de 11px no azul).
          <button
            type="button"
            onClick={() => limparEFocarNaBuscaDaFilaEcoa(onLimparFiltros)}
            className={`mt-1 self-start rounded-jj-sm border-0 bg-brand-blue-dark px-5 py-[11px] text-[11px] font-bold uppercase tracking-[0.04em] text-brand-yellow ${FOCO_VISIVEL}`}
          >
            Limpar filtros
          </button>
        )}
      </div>
    </div>
  );
}
